import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { AlertCircle, ArrowLeft, Home } from 'lucide-react';

/**
 * FeatureNotAvailable Component
 * Friendly message shown when user tries to access a disabled feature
 */
export const FeatureNotAvailable = ({ featureId, message }) => {
  const navigate = useNavigate();
  
  const defaultMessage = "This feature is temporarily unavailable. Please check back later.";
  const displayMessage = message || defaultMessage;
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950 p-4">
      <Card className="max-w-md w-full">
        <CardContent className="pt-6">
          <div className="text-center space-y-4">
            {/* Icon */}
            <div className="flex justify-center">
              <div className="rounded-full bg-yellow-100 dark:bg-yellow-900/20 p-4">
                <AlertCircle className="h-12 w-12 text-yellow-600 dark:text-yellow-500" />
              </div>
            </div>
            
            {/* Title */}
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                Feature Not Available
              </h1>
              <p className="text-muted-foreground">
                {displayMessage}
              </p>
            </div>
            
            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-3 pt-4">
              <Button
                variant="outline"
                onClick={() => navigate(-1)}
                className="flex-1 gap-2"
              >
                <ArrowLeft className="h-4 w-4" />
                Go Back
              </Button>
              <Button
                onClick={() => navigate('/app/home')}
                className="flex-1 gap-2"
              >
                <Home className="h-4 w-4" />
                Go Home
              </Button>
            </div>
            
            {/* Support Message */}
            <p className="text-xs text-muted-foreground pt-4">
              If you believe this is an error, please contact support.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
